<button
  [attr.data-testId]="'delete-row' + context?.row.index"
  mat-flat-button
  color="warn"
  class="deleteButton qa-grid-delete-btn"
  (click)="context?.row?.actions?.delete()"
  [disabled]="!context?.row?.allowDeleting"
  data-testId="delete"
>
  <mat-icon svgIcon="delete"></mat-icon>
</button>
